import React from "react";
import styled from "@emotion/styled";

const Wrapper = styled.section`
  position: relative;
  border-radius: 3px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
  border-style: solid;
  border-width: 0 0 0 4px;
  border-color: ${({ theme }) => theme.colors.grey30};
  background-color: #f2f2f2;
  max-width: 420px;
  margin-bottom: -8px;
  ${({ theme }) => theme.breakpoints.sm.up} {
    margin-bottom: 16px;
  }

  ${({ type }) =>
    type === "warning" &&
    `
    border-color: #CC6700;
    background-color: #FFF8E0;
  `}
  ${({ type, theme }) =>
    type === "bidenWon" &&
    `
    border-color: ${theme.colors.democratic};
    background-color: #EBF4FF;
  `}
  ${({ type, theme }) =>
    type === "trumpWon" &&
    `
    border-color: ${theme.colors.republican};
    background-color: #FFECEC;
  `}
`;

const Header = styled.header`
  padding: 10px 16px 8px 12px;
  color: ${({ theme }) => theme.colors.black};
  background-color: #fafafa;
  border-bottom: 1px solid #ffffff;

  ${({ type }) =>
    type === "warning" &&
    `
    color: #CC6700;
    background-color: #FFFBED;
  `}
  ${({ type, theme }) =>
    type === "bidenWon" &&
    `
    color: ${theme.colors.democratic};
    background-color: #F7FAFF;
  `}
  ${({ type, theme }) =>
    type === "trumpWon" &&
    `
    color: ${theme.colors.republican};
    background-color: #FFF5F5;
  `}
`;

const Title = styled.span`
  font-weight: 700;
  font-size: 15px;
  line-height: 1.2;
  ${({ theme }) => theme.breakpoints.sm.up} {
    font-size: 16px;
  }
`;

const Body = styled.main`
  margin: 0;
  padding: 12px 16px 14px 12px;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5;
  ${({ theme }) => theme.breakpoints.sm.up} {
    font-size: 15px;
  }
`;

function Message({ title, type = "neutral", children }) {
  return (
    <Wrapper type={type}>
      {title && (
        <Header type={type}>
          <Title>{title}</Title>
        </Header>
      )}
      {children && <Body>{children}</Body>}
    </Wrapper>
  );
}

export default Message;
